import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { cn } from '../lib/utils';
import { phases, systemIncludes, tools } from '../data/system';
export function SystemBlueprint() {
  return <section aria-label="6 aşamalı uzun mesafe triatlon planı" className="bg-navy text-white" data-id="element-263" data-mp="29sbrptbvo7vl">
      <div className="mx-auto max-w-6xl px-5 py-16 lg:py-24" style={{
      paddingTop: "20px",
      paddingBottom: "28px"
    }} data-id="element-264" data-mp="24u0i9jphvzdw">
        <div className="mx-auto max-w-3xl text-center" data-id="element-265" data-mp="1zx1r9a14o8jx">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-aqua" data-id="element-266" data-mp="1vtvl02e0mhdg">
            UZUN MESAFE TRİATLON SİSTEMİ™ · 6 aşamalı kapsamlı hazırlık sistemi
          </p>
          <h2 className="mt-4 font-display text-4xl font-extrabold uppercase leading-[0.95] sm:text-6xl" data-id="element-267" data-mp="1lw7e6e34xjex">
            Antrenmandan bitiş çizgisine kadar tüm yolculuğunuzu organize etmek için tek bir sistem.
          </h2>
          <p className="mt-5 text-lg font-semibold text-white/70" data-id="element-268" data-mp="3g9p427r0isd4">6 Aşamalı Uzun Mesafe Triatlon Planı</p>
        </div>

        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-269" data-mp="yvsgb91bitzb">
          {phases.map((p, idx) => {
          const Icon = p.icon;
          return <motion.article key={p.n} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-40px'
          }} transition={{
            duration: 0.3,
            delay: idx % 3 * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex h-full flex-col rounded-2xl border border-white/10 bg-obsidian/60 p-6" data-id="element-270" data-mp="12vu7updca70v" data-mpi={idx}>
                <div className="flex items-center justify-between" data-id="element-271" data-mp="17xjiw50kakoy">
                  <span className="font-display text-5xl font-extrabold leading-none text-electric" data-id="element-272" data-mp="17v5qk3x9nml3">{p.n}</span>
                  <span className="rounded-md border border-aqua/25 bg-aqua/10 px-2 py-1 text-[11px] font-semibold uppercase tracking-wider text-aqua" data-id="element-273" data-mp="1cu0872jhz53m">
                    {p.weeks}
                  </span>
                </div>
                <div className="mt-4 flex gap-1" aria-hidden="true" data-id="element-274" data-mp="2f95zi6nagomi">
                  {phases.map((_, k) => <span key={k} className={cn('h-1 flex-1 rounded-full', k < idx ? 'bg-perf' : k === idx ? 'bg-electric' : 'bg-white/10')} data-id="element-275" data-mp="2a9t3avaj2579" data-mpi={k} />)}
                </div>
                <h3 className="mt-5 font-display text-2xl font-extrabold uppercase leading-tight" data-id="element-276" data-mp="25cjf1iyvjzl0">{p.title}</h3>
                <p className="mt-2 font-semibold leading-snug text-white" data-id="element-277" data-mp="21b7kr0522q6h">{p.lead}</p>
                <p className="mt-2 text-sm leading-relaxed text-white/65" data-id="element-278" data-mp="1wbv08m1npv72">{p.desc}</p>
                <p className="mt-auto flex items-center gap-2 pt-5 text-xs font-semibold uppercase tracking-wider text-white/45" data-id="element-279" data-mp="1rhgxtzokunsw">
                  <Icon className="h-4 w-4 text-aqua" aria-hidden="true" data-id="element-280" data-mp="1hkvv5l015os8" />
                  Aşama {p.n} / 06
                </p>
              </motion.article>;
        })}
        </div>

        <div className="mt-14" data-id="element-281" data-mp="1dihftavkl75p">
          <p className="text-center font-display text-2xl font-extrabold uppercase sm:text-3xl" data-id="element-282" data-mp="18kfuejao8vr2">
            Ayrıca 4 performans bonusu
          </p>
          <p className="mx-auto mt-2 max-w-xl text-center text-sm text-white/60" data-id="element-283" data-mp="3k715w3exnrw6">
            Uzun mesafe triatlon hazırlığınızı tek bir sistem içerisinde organize etmenize yardımcı olacak dört ek araç.
          </p>
          <ol className="mt-8 grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-white/10 bg-white/10 lg:grid-cols-4" data-id="element-284" data-mp="3t64qjbtr0fcs">
            {tools.map(({
            verb,
            name,
            icon: Icon
          }) => <li key={verb} className="flex flex-col gap-3 bg-navy p-5" data-id="element-285" data-mp="31f8dob7ouapi">
                <Icon className="h-5 w-5 text-electric" aria-hidden="true" data-id="element-286" data-mp="35j6b8hhd7dgg" />
                <p className="font-display text-3xl font-extrabold uppercase leading-none" data-id="element-287" data-mp="3agoogk2f0eu9">{verb}</p>
                <p className="text-sm leading-snug text-white/60" data-id="element-288" data-mp="3f9hrn3i8jf48">{name}</p>
              </li>)}
          </ol>
        </div>

        <div className="mt-14 rounded-2xl border border-white/10 bg-obsidian/50 p-6 sm:p-8" data-id="element-289" data-mp="2hssj6qys5elv">
          <p className="font-display text-2xl font-extrabold uppercase" data-id="element-290" data-mp="2mqknkkgm2t6y">Sistemin içeriğinde neler var?</p>
          <ul className="mt-6 grid gap-x-6 gap-y-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-291" data-mp="t9odo9fhqhte">
            {systemIncludes.map(item => <li key={item} className="flex items-start gap-2.5 text-[15px] text-white/80" data-id="element-292" data-mp="o88t0ih86dbj">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-perf" strokeWidth={3} aria-hidden="true" data-id="element-293" data-mp="123uon8hyrvcx" />
                {item}
              </li>)}
          </ul>
          <p className="mt-6 border-t border-white/10 pt-5 text-[15px] font-semibold text-white" data-id="element-294" data-mp="1byv1ubz201ml">
            Tüm bu başlıkları tek bir hazırlık sistemi içerisinde organize edin.
          </p>
        </div>
      </div>
    </section>;
}